module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-about-mockup-4fb3dfb12f61a9115899b758cec7bea3.png";